import { ReactNode, useMemo } from 'react'
// @mui
import { CssBaseline } from '@mui/material'
import {
  ThemeProvider as MUIThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles'
// hooks
import useSettings from '../hooks/useSettings'
//
import { createAppTheme } from './createAppTheme'

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode
}

export default function ThemeProvider({ children }: Props) {
  const { themeMode } = useSettings()

  const theme = useMemo(
    () => createAppTheme(themeMode === 'dark' ? 'dark' : 'light'),
    [themeMode],
  )

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  )
}
